// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: 外見動画一覧
const AdminOpsAppearanceListApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_appearance_list";

    const ExecAdminOpsAppearanceListApi = async () => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: {} });
    };

    return ExecAdminOpsAppearanceListApi;
};

export default AdminOpsAppearanceListApi;
